/**
 * Tri d'une liste affichee par le composant `Tableau` (2026-09-29).
 *
 * Dans son propre module, et non dans `Elements.tsx` : ce fichier
 * n'exporte que des composants, et le rechargement a chaud le veut ainsi.
 */
export interface Tri {
  cle: string;
  sens: 'asc' | 'desc';
}

/** Ce qu'une colonne doit fournir pour etre triable. */
export interface ColonneTriable<T> {
  cle: string;
  valeurTri?: (ligne: T) => string | number | null | undefined;
}

/**
 * Les lignes dans l'ordre d'un tri. Un nombre se compare en nombre, un
 * texte en francais sans tenir compte de la casse ; `null` va en fin de
 * liste. Exportee pour que l'ecran qui porte l'etat du tri — celui qui
 * exporte — trie les memes lignes que le tableau affiche.
 */
export function trierLignes<T>(lignes: T[], colonnes: ColonneTriable<T>[], tri: Tri | null): T[] {
  const colonne = tri && colonnes.find((c) => c.cle === tri.cle);
  if (!tri || !colonne?.valeurTri) return lignes;
  const valeur = colonne.valeurTri;
  const sens = tri.sens === 'asc' ? 1 : -1;
  return [...lignes].sort((a, b) => {
    const va = valeur(a);
    const vb = valeur(b);
    if (va === vb) return 0;
    if (va === null || va === undefined) return 1;
    if (vb === null || vb === undefined) return -1;
    if (typeof va === 'number' && typeof vb === 'number') return (va - vb) * sens;
    return String(va).localeCompare(String(vb), 'fr', { sensitivity: 'base' }) * sens;
  });
}
